export default {
	inserted: function (el) {
		if (!window.navigator.onLine) {
			el.classList.add('disabled')
			el.setAttribute('disabled', true)
			el.classList.add('online-only')
		}
	}
}
